import React, { ErrorInfo, ReactNode } from "react";
import fetchIp from "../../helpers/fetchIp";
import ErrorPage from "../ErrorPage";
import postDiscordMessage from "../../helpers/postDiscordMessage";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };
  private ERROR_MESSAGE = `Pedimos desculpas pela inconveniência, mas parece que ocorreu um erro em nosso site. Por favor, entre em contato com nossa equipe para obter assistência.`;
  constructor(props: ErrorBoundaryProps) {
    super(props);
  }

  /** Default method provided by React that triggers upon catching error. */
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.reportError(error, errorInfo);
    this.setState({ hasError: true });
  }

  /** Map callback for the reportError function string formatting */
  private mapErrorArgs(a: any) {
    return `\`\`\`json\n${a instanceof Error ? a : JSON.stringify(a, null, 2)}\n\`\`\``;
  }

  /** Reports Error by sending it to discord along with the customer IP */
  private async reportError(...args: any[]) {
    try {
      const ip = await fetchIp();
      const message = `
🚨 Error caught in [\`signup-page\`]
This error was caught by an error boundary in the signup page.\n
🧑 Customer IP: \`${ip}\`\n
${args.map(this.mapErrorArgs).join("\n")}
      `;
      postDiscordMessage(message);
    } catch (err) {}
  }

  render() {
    return this.state.hasError ? <ErrorPage message={this.ERROR_MESSAGE} /> : this.props.children;
  }
}
